import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HighlightText from "../components/core/HomePage/HighlightText";
import CodeBlocks from "../components/core/HomePage/CodeBlocks";
import Footer from "../components/common/Footer";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import FmgeCourse from "../components/core/HomePage/fmgeCourse";
import Fmgetabs from "../components/core/HomePage/FmgeTabs";
import fmgVid from "../assets/Images/fmgeVid.mp4";
import gif from "../assets/Images/1.gif";
import gif1 from "../assets/Images/Gif2.gif";
import FaqSection from "./FaqSection";

const Fmge = () => {
  const [marqueeLoaded, setMarqueeLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMarqueeLoaded(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const sectionVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <div>
      <div
        className="relative mx-auto flex flex-col w-11/12 max-w-maxContent items-center
      text-white dark:text-white justify-between"
      >
        <div className="w-full">
          <Link to="/events">
            <div
              className={`h-10 mt-5 flex items-center text-center rounded-2xl overflow-hidden bg-richblack-25 dark:bg-yellow-5 ${
                marqueeLoaded ? "" : "hidden"
              }`}
            >
              <div className="overflow-hidden whitespace-nowrap">
                <div className="inline-block animate-marquee text-[#1A56DB] text-2xl font-bold">
                  NEET 2025 results out
                  <span className="mx-2 px-2 py-1 text-[#9B1C1C] rounded animate-pulse">
                    Cut off - general catagory 144 and for Obc /SC/ST - 113
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp; NEET 2025 results out
                  <span className="mx-2 px-2 py-1 text-[#9B1C1C] rounded animate-pulse">
                    Cut off - general catagory 144 and for Obc /SC/ST - 113
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          className="text-center text-4xl font-semibold mt-7 text-richblack-600 dark:text-white"
        >
          Start learning today
          <HighlightText text={"Foreign Medical Graduate Examination"} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          className=" mt-4 w-[90%] text-center text-lg font-bold text-richblack-300 dark:text-richblack-25"
        >
          A mandatory licensure exam in India for Indian citizens and Overseas
          Citizens of India (OCI) who have completed their medical studies
          abroad and want to practice medicine in India. This exam, conducted by
          the National Board of Examinations (NBE), ensures that foreign-trained
          doctors meet the required standards and competencies to practice
          medicine in the country.
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          className="flex flex-row gap-7 mt-8"
        >
          {/* <CTAButton onClick={() => setEnquiryForm(true)}>Enroll Now</CTAButton> */}
        </motion.div>

        <motion.div
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={sectionVariants}
          className="mx-3 my-12 w-[80%] dark:shadow-[0px_0px_30px_-5px_white]
                 rounded-2xl shadow-[0px_0px_30px_-10px_#1a202c] "
        >
          <video muted loop autoPlay className="rounded-2xl overflow-hidden">
            <source src={fmgVid} type="video/mp4" />
          </video>
        </motion.div>

        {/* slider  */}
        <div className="homepage w-screen">
          <div className="flex justify-center text-center">
            <h1 className=" bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#FCB045] bg-clip-text text-5xl font-semibold text-transparent w-[70%] underline">
              Services we offered
            </h1>
          </div>
          <FmgeCourse />
        </div>

        {/* Code Section 1 */}
        <div className="border border-b-richblack-100 dark:border-none dark:text-white">
          <CodeBlocks
            position={"lg:flex-row"}
            heading={
              <div className="text-4xl font-semibold text-richblack-900 dark:text-white">
                FMGE 2025 Registration and Application Details
              </div>
            }
            subheading={
              <div>
                <div className=" max-w-2xl mx-auto px-4">
                  <ul className="list-disc ml-6 mt-2 space-y-2">
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 1:</strong>{" "}
                      Visit the official website of NBE and click on the ‘FMGE’
                      tab on the homepage. Click on the ‘Registration’ tab and
                      enter your personal details, including your name, date of
                      birth, email address, and phone number.
                    </li>
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 2:</strong>{" "}
                      Upload scanned copies of your passport-sized photograph
                      and signature in the specified format.
                    </li>
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 4:</strong>{" "}
                      Enter your educational details, including your primary
                      medical qualification, the name of the institution, and
                      the duration of the study.
                    </li>
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 5:</strong>{" "}
                      Select the examination centre of your choice from the
                      available options.
                    </li>
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 6:</strong>{" "}
                      Pay the registration fee using the online payment mode.
                    </li>
                    <li className="text-richblack-600">
                      <strong className="text-richblack-900">Step 7:</strong>{" "}
                      Submit the registration form and take a printout of the
                      confirmation page for future reference.
                    </li>
                  </ul>
                </div>
              </div>
            }
            ctabtn1={{
              btnText: "Contact us",
              // link: "https://nbe.edu.in/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              // link: "fmge-details",
              active: false,
            }}
            gifSrc={gif}
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div>

        {/* Code Section 2 */}
        <div>
          <CodeBlocks
            position={"lg:flex-row-reverse"}
            heading={
              <div className="w-[100%] text-4xl font-semibold lg:w-[90%] text-richblack-900 dark:text-richblack-5">
                FMGE 2025 Eligibility Criteria
              </div>
            }
            subheading={
              <div>
                <ul className="list-disc ml-6">
                  <li className="text-richblack-600">
                    <strong className="text-richblack-900">Nationality:</strong>{" "}
                    Must be an Indian Citizen or Overseas Citizen of India (OCI)
                  </li>
                  <li className="text-richblack-600">
                    <strong className="text-richblack-900">
                      Qualification:
                    </strong>{" "}
                    Must have a primary medical degree from a recognized foreign
                    institution and confirmed by the Indian Embassy
                  </li>
                  <li className="text-richblack-600">
                    <strong className="text-richblack-900">
                      Documents Required:
                    </strong>{" "}
                    Proof of medical qualification is mandatory
                  </li>
                  <li>
                    <strong className="text-richblack-900">
                      Result Timeline:
                    </strong>{" "}
                    Results of the final exam are expected to be declared in
                    June 2025
                  </li>
                </ul>
              </div>
            }
            ctabtn1={{
              btnText: "Contact Us",
              // link: "https://nbe.edu.in/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              // link: "fmge-details",
              active: false,
            }}
            gifSrc={gif1} // Pass your gif URL or import
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div>

        <div className="flex flex-col items-center justify-center px-4 sm:px-6 py-10 sm:py-12 bg-gradient-to-r from-purple-500 to-red-[#9B1C1C] text-white w-full">
          <section className="w-full  flex flex-col items-center justify-center px-4 sm:px-8 py-10 sm:py-12 bg-black bg-opacity-90 text-white rounded-lg shadow-xl">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-6 sm:mb-8 transition duration-300 transform hover:scale-105 hover:text-[#9B1C1C] hover:shadow-lg hover:shadow-pink-500/50">
              Tips for FMGE Preparation
            </h2>

            <div className="w-full bg-richblack-700 p-5 sm:p-8 rounded-xl shadow-xl space-y-6 sm:space-y-8">
              <ul className="list-disc pl-4 sm:pl-6 space-y-5 text-base sm:text-lg text-richblack-25">
                {[
                  {
                    icon: (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 10V3H4v16h16V10h-7zm-4 7h7V5H9v12z"
                      />
                    ),
                    text: (
                      <>
                        <strong className="font-bold">
                          Familiarize Yourself with the Syllabus:
                        </strong>{" "}
                        Understand all topics in FMGE like anatomy,
                        pharmacology, pathology, etc., as provided by NBE.
                      </>
                    ),
                  },
                  {
                    icon: (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 3v12a9 9 0 0 0 9 9 9 9 0 0 0 9-9V3m-9 3v12a6 6 0 0 1-6 6 6 6 0 0 1-6-6V6h12z"
                      />
                    ),
                    text: (
                      <>
                        <strong className="font-bold">
                          Develop a Study Plan:
                        </strong>{" "}
                        Make a weekly/monthly study schedule including breaks
                        and revision periods to stay on track.
                      </>
                    ),
                  },
                  {
                    icon: (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5v6h6V5H9zm0 0L6 8.5M6 8.5L9 12"
                      />
                    ),
                    text: (
                      <>
                        <strong className="font-bold">
                          Use Study Materials:
                        </strong>{" "}
                        Refer to textbooks, FMGE-specific guidebooks, and
                        reliable online resources for each subject.
                      </>
                    ),
                  },
                  {
                    icon: (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5v10h6V5H9z"
                      />
                    ),
                    text: (
                      <>
                        <strong className="font-bold">Take Mock Tests:</strong>{" "}
                        Regularly test yourself with mock exams to evaluate your
                        strengths and improve time management.
                      </>
                    ),
                  },
                  {
                    icon: (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 2h-4v4h4V2zm0 12H8v4h6v-4z"
                      />
                    ),
                    text: (
                      <>
                        <strong className="font-bold">
                          Practice Regularly:
                        </strong>{" "}
                        Solve MCQs and previous years’ question papers
                        consistently to improve speed and accuracy.
                      </>
                    ),
                  },
                ].map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 hover:bg-[#9B1C1C] p-3 rounded-lg transition-all duration-300"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-400 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      {item.icon}
                    </svg>
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
        <div>
          <Fmgetabs />
        </div>
      </div>

      {/*Section 2  */}
      <div className=" text-richblack-700">
        <div className="homepage_bg h-[310px]  bg-richblack-5">
          <div className="w-11/12 max-w-maxContent flex flex-col items-center justify-between gap-5 mx-auto">
            <div className="h-[200px]"></div>
          </div>
        </div>
      </div>
      <div></div>
      <FaqSection />
      <Footer />
    </div>
  );
};

export default Fmge;
